import { ChartA } from '../../utils/canvas_chart/chart-a.js';
import { ChartB } from '../../utils/canvas_chart/chart-b.js';
import { ChartC } from '../../utils/canvas_chart/chart-c.js';

const userColor = '#c6c031';
const companyColor = '#0f93e6';

const chartDefs = [
  { id: 'resultChartA', ChartClass: ChartA },
  { id: 'resultChartB', ChartClass: ChartB },
  { id: 'resultChartC', ChartClass: ChartC },
];

// data 属性のスコア配列を安全に取り出す（数値でない要素は 0 に倒す）。
const parseScore = (value) => {
  if (!value) return null;

  try {
    const score = JSON.parse(value);
    if (!Array.isArray(score)) return null;

    return score.map((item) => {
      const number = Number(item);
      return Number.isFinite(number) ? number : 0;
    });
  } catch (error) {
    return null;
  }
};

// canvas に既に何か描かれているか。差し替え後の白紙 canvas を見分けるために使う。
const isPainted = (canvas) => {
  try {
    const data = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data;
    for (let i = 3; i < data.length; i += 4) {
      if (data[i] > 0) return true;
    }
  } catch (error) {
    // 読めない場合は未描画扱いにして描画を試みる。
  }
  return false;
};

// 渡された canvas に実際に描く。
const drawChart = (canvas, ChartClass) => {
  const canvasWrapper = canvas.parentElement;
  const userScore = parseScore(canvas.dataset.userScore);
  const companyScore = parseScore(canvas.dataset.companyScore);

  const chart = new ChartClass(canvas, canvasWrapper);
  userScore && chart.addChart({ color: userColor, score: userScore });
  companyScore && chart.addChart({ color: companyColor, score: companyScore });
  chart.render();
};

// 初期描画。getElementById で「今その瞬間に画面にある本物の canvas」を取り直して描く。
// turbolinks 等で DOM が差し替わると、描画した canvas が捨てられて別の白紙 canvas が
// 残ることがある（実機で発生）。毎回取り直すことで、最終的に表示されている canvas に
// 確実に描ける。戻り値は「表示中の canvas が描けているか」。
const renderChart = (id, ChartClass) => {
  const canvas = document.getElementById(id);
  if (!canvas) return false;

  const canvasWrapper = canvas.parentElement;
  if (!canvasWrapper || canvasWrapper.clientWidth <= 0) return false;

  if (isPainted(canvas)) return true;

  drawChart(canvas, ChartClass);
  return isPainted(canvas);
};

const setupCharts = () => {
  chartDefs.forEach(({ id, ChartClass }) => {
    // 一定時間ポーリングし続ける。毎回 getElementById で本物を取り直すので、
    // 描画途中で DOM が差し替わっても、差し替え後に表示されている canvas へ描き直せる。
    // ※ 一度描けたら止める設計は NG：差し替え前の捨てられる canvas に描いて止まり、
    //   表示中の本物が白紙のまま残る（実機で発生）。描けても止めずに粘る。
    //   renderChart は表示中の canvas が既に描けていれば何もしないので、無駄描きはしない。
    let attempts = 0;
    const tick = () => {
      renderChart(id, ChartClass);
      attempts += 1;
      if (attempts < 40) setTimeout(tick, 120); // 最大 ~5 秒
    };
    tick();
  });
};

// 画面リサイズに追従して描き直す（その時点の本物の canvas を対象にする）。
window.addEventListener('resize', () => {
  chartDefs.forEach(({ id, ChartClass }) => {
    const canvas = document.getElementById(id);
    if (canvas && canvas.parentElement && canvas.parentElement.clientWidth > 0) {
      drawChart(canvas, ChartClass);
    }
  });
});

// turbolinks 遷移ごとに初期化。ネイティブの addEventListener で登録することで、
// 同じ turbolinks:load に jQuery で登録された他スクリプトのハンドラが例外を投げても、
// その巻き添えで描画処理がスキップされないようにする。
document.addEventListener('turbolinks:load', setupCharts);

// 初回フルロードでの取りこぼしに備え、DOM が準備済みなら即実行する。
if (document.readyState !== 'loading') {
  setupCharts();
} else {
  document.addEventListener('DOMContentLoaded', setupCharts);
}
